"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Component = require("react").Component;

var mitt = require("mitt");

if (mitt.default) {
  mitt = mitt.default;
}

module.exports = function send() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Send";
  var emitter = mitt();

  var Input =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Input, _Component);

    function Input() {
      _classCallCheck(this, Input);

      return _possibleConstructorReturn(this, _getPrototypeOf(Input).apply(this, arguments));
    }

    _createClass(Input, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        emitter.emit("update", this.props.children);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        emitter.emit("update", this.props.children);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        emitter.emit("update", null);
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return Input;
  }(Component);

  _defineProperty(Input, "displayName", "".concat(name, ".Input"));

  var Output =
  /*#__PURE__*/
  function (_Component2) {
    _inherits(Output, _Component2);

    function Output() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Output);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Output)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        children: null
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_onUpdate", function (children) {
        _this.setState({
          children: children
        });
      });

      return _this;
    }

    _createClass(Output, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        emitter.on("update", this._onUpdate);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        emitter.off("update", this._onUpdate);
      }
    }, {
      key: "render",
      value: function render() {
        return this.state.children;
      }
    }]);

    return Output;
  }(Component);

  _defineProperty(Output, "displayName", "".concat(name, ".Output"));

  return {
    Input: Input,
    Output: Output
  };
};

module.exports.default = module.exports;